import { Outlet } from "react-router";

const PilotLayout = () => {
  return (
      <>
          <Outlet />
      </>
  );
};

export default PilotLayout;